import axios, {AxiosError, AxiosResponse} from "axios";
import {AUTH_LS_KEY, getAuth, removeAuth} from "../modules/auth";
import {get} from "lodash"
import {URL_AUTH_LOGIN} from "../mock/page_urls";
import {BASE_API_URL, TOKEN_REFRESH} from "../mock/URLs";

export const api = axios.create({
  baseURL: BASE_API_URL
})


export const apiWithoutToken = axios.create({
  baseURL: BASE_API_URL
})


api.interceptors.request.use((config) => {
  config.headers["Accept-Language"] = "uz";
  return config;
}, (error) => {
  return Promise.reject(error);
});


class APIError {
  status: number;
  data: {
    message: string;
    status: string;
  };

  constructor(data: any, status: number) {
    this.status = status;
    this.data = data;
  }
}

const refresh = async () => {
  try {
    const response = await axios.post(`${BASE_API_URL}${TOKEN_REFRESH}`, {
      refresh: getAuth()?.refresh,
    });
    const newAccessToken = response.data.access;
    setHeaderToken(newAccessToken);
    const lsValue = JSON.stringify({
      access: newAccessToken,
      refresh: getAuth()?.refresh,
    });
    localStorage.setItem(AUTH_LS_KEY, lsValue);
    return newAccessToken;
  } catch (error) {
  }
};

api.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    async (err: AxiosError) => {
      const data = get(err, "response");
      const status = err.response?.status || 500;

      switch (status) {
        case 401: {
          const errorMessage = get(data, "data.code");
          if (errorMessage === "user_not_found") {
            removeAuth();
            window.location.href = URL_AUTH_LOGIN;
            return Promise.reject(new APIError(data || err, 401));
          }

          try {
            const newToken = await refresh();
            if (newToken && err.config) {
              err.config.headers["Authorization"] = `Bearer ${newToken}`;
              return api.request(err.config);
            }
          } catch (refreshError) {
            removeAuth();
            window.location.href = URL_AUTH_LOGIN;
            return Promise.reject(refreshError);
          }
          break;
        }

        case 403: {
          return Promise.reject(new APIError(data || err, 403));
        }

        case 400: {
          return Promise.reject(new APIError(data || err, status));
        }

        case 404: {
          return Promise.reject(new APIError(data || err, 404));
        }

        case 409: {
          return Promise.reject(new APIError(data || err, 409));
        }

        case 422: {
          return Promise.reject(new APIError(data || err, 422));
        }

        default: {
          return Promise.reject(new APIError(data || err, 500));
        }
      }
    }
);


export const setHeaderToken = (token: string) => {
  api.defaults.headers.Authorization = `Bearer ${token}`;
};

export const removeHeaderToken = () => {
  delete api.defaults.headers.Authorization;
};
